import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Button from '../../../../../../../../components/Button'
import MultipleOptionsField from '../../../../../../../ReusableFormFields/MultipleOptionsField'

import { LONG_HEADLINES_LIST, longHeadlineMaxLength } from '../../../../../fields'

import useStyles from '../../../../../../../../styles/common/stepForms'

const stepFields = [LONG_HEADLINES_LIST]

function LongHeadlinesStep({ formik, handleStepChange }) {
  const { t } = useTranslation()
  const commonClasses = useStyles()

  const { values } = formik

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields, values)
  }, [handleStepChange, values])

  return (
    <>
      <div className={commonClasses.stepTitle}>{t('Add up to 5 long headlines (at least 2)')}</div>
      <div className={commonClasses.stepBody}>
        <p>
          {t(
            'The long headline is the first line of your ad and appears instead of your short headline in larger ads. ' +
              'Long headlines can be up to 90 characters, and may appear with or without your description.'
          )}
        </p>
        <MultipleOptionsField
          fieldLabel="Long Headline"
          fieldMaxLength={longHeadlineMaxLength}
          listFieldName={LONG_HEADLINES_LIST}
          formik={formik}
          minListQuantity={2}
        />
      </div>
      <div className={commonClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

LongHeadlinesStep.propTypes = {
  handleStepChange: PropTypes.func,
  formik: PropTypes.object
}

export default LongHeadlinesStep
